/* Artikelnummer kopieren (TSI - 4.3.7), Markup: snippets/tsi-sku-copy.liquid */
class TsiCopy extends HTMLElement {
  connectedCallback() {
    if (this._bound) return;
    this._bound = true;
    this.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      this.copy();
    });
    this.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        e.stopPropagation();
        this.copy();
      }
    });
  }

  async copy() {
    const value = this.dataset.value || '';
    try {
      await navigator.clipboard.writeText(value);
    } catch (err) {
      const t = document.createElement('textarea');
      t.value = value;
      t.setAttribute('readonly', '');
      t.style.position = 'fixed';
      t.style.opacity = '0';
      document.body.appendChild(t);
      t.select();
      try { document.execCommand('copy'); } catch (e) {}
      t.remove();
    }
    this.classList.add('is-done');
    this.title = this.dataset.done || '';
    clearTimeout(this._timer);
    this._timer = setTimeout(() => {
      this.classList.remove('is-done');
      this.title = this.dataset.label || '';
    }, 1500);
  }
}

if (!customElements.get('tsi-copy')) customElements.define('tsi-copy', TsiCopy);